import tmdb from './client';

const Credit = (id, config = {}) =>
  tmdb.get(`/movie/${id}/credits`, {
    ...config,
    params: { language: 'en-US', ...(config.params || {}) },
  });

export default Credit;
